declare const window: any;
import { getCookie, setCookie } from '@/utils/cookie'
import { matomoSetCustomDimension } from './matomoEvent';

// 自定义过期时间，保持跟matomo一致，30分钟(时间戳)
const matomoExpiresTime = new Date().getTime() + 60 * 60 * 1000 * 0.5
// 上报数据
function uploadLog(requestData: any) {
  let currentDomain = window.location.hostname;
  if (currentDomain != 'www.crazysales.com.au') {
    return
  }

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestData),
  };

  return fetch("https://www.crazysales.com.au/fp/log", requestOptions)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch((error: any) => {
      console.log(error);
    });
}

// 上报回第一次数据给后端并设置
function uploadFirstData() {

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    // body: JSON.stringify(),
  };

  return fetch(`/tracking/dataAnalysis?URL=${window.location.href}`, requestOptions)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch(error => {
      console.log(error);

    });
}

// 推送matomoID
function sendMatomoId(matomoId: any) {
  if (window._paq) {
    window._paq.push(['setVisitorId', matomoId]);
    window._paq.push(['trackPageView']);
  } else {
    setTimeout(() => {
      sendMatomoId(matomoId)
    }, 200);
  }
}


const allocateBucket = (conf: any, bucketId: number) => {
  let keys = Object.keys(conf);
  let oldKey = undefined;
  let begin = 0;
  let end = 0;
  for (let idx in keys) {
    let key = keys[idx];
    if (!oldKey) {
      end = conf[key];
    } else {
      begin += conf[oldKey];
      end += conf[key];
    }

    if (bucketId >= begin && bucketId < end) {
      return key;
    }

    oldKey = key;
  }
}

const hash = (uid: string, salt: number) => {
  let h1 = 0xdeadbeef ^ salt, h2 = 0x41c6ce57 ^ salt;
  for (let i = 0, ch; i < uid.length; i++) {
    ch = uid.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

const calculate = (visitorId: string, response: any, isFirst: boolean) => {
  const { experimentName, group, expiresTime } = response
  let conf: any = {};
  for (let idx in group) {
    conf[idx] = group[idx].ratio
  }
  const salt = Object.keys(conf).length;
  const h = hash(visitorId, salt);
  const bucketId = h % 100;
  const bucket = allocateBucket(conf, bucketId);

  const expiresTimeNum = new Date(expiresTime).getTime()
  const nowTimeNum = new Date().getTime()

  // 判断ABtest是否在进行
  if (expiresTimeNum > nowTimeNum && !!bucket) {
    // 使用过期时间做为cookie过期时间，防止过期时间还没到但是算不出来的情况导致cookie失效问题
    settingCookie(expiresTimeNum, experimentName, bucket)
  } else {
    // 失效或者未算出
    settingCookie(matomoExpiresTime, experimentName, "A")

    const errorData = JSON.stringify({ expiresTimeNum, nowTimeNum, bucket })
    // 日志上传
    const params = {
      conf: errorData,
      bucketId: "calculate-error",
      experimentName: experimentName
    }
    uploadLog(params)
  }

  if (isFirst) {
    uploadFirstData()
  }
  // var unique_id = getCookie("unique_id")
  // 日志上传
  // const params = {
  //   conf: conf || 'null',
  //   visitorId: visitorId || 'null',
  //   bucketId: bucketId || 'null',
  //   bucket: bucket || 'null',
  //   uniqueId: unique_id || 'null',
  //   experimentName: experimentName || 'null'
  // }
  // uploadLog(params)

  return bucket
}

// type : api|mixture|direct ,   api方式|混合模式（部分页面API｜部分后端渲染｜后端渲染）
export const abTestCalculate = async (name: string) => {
  const { _bfuid, isFirst }: any = await settingBfuid()

  const abtestPromise = new Promise((resolve, reject) => {
    if (isFirst) {
      // bfuid第一次生成或者失效，获取abtest配置信息，并计算ABtest分组
      getGroup(name, _bfuid, isFirst, resolve)
    } else {
      // 非第一次生成，直接使用缓存数据
      const serviceGroup = getCookie("X-Service-Group-AB")
      const serviceGroupName = getCookie("X-AB-Experiment-Name")
      if (!serviceGroup || !serviceGroupName) {
        // 分组丢失，重新获取分组信息
        getGroup(name, _bfuid, isFirst, resolve)
      } else {
        resolve(serviceGroup)
      }
    }
  })
  abtestPromise.catch((error: any) => {
    settingCookie(matomoExpiresTime, name, "A")
    // 日志上传
    const params = {
      conf: error.message || null,
      bucketId: "promise-error",
      experimentName: name
    }
    uploadLog(params)
  })
  return abtestPromise
}

// 通过时间戳生成一个唯一标识
const generateMatomoVisitorId = (): string => {
  const timestampHex = Date.now().toString(16).slice(-8); // 取时间戳后8位 hex
  const array = new Uint8Array(4); // 4字节 = 8位 hex
  window.crypto.getRandomValues(array);
  const randHex = Array.from(array).map(b => b.toString(16).padStart(2, '0')).join('');
  return (timestampHex + randHex).slice(0, 16);
};




const settingBfuid = async () => {
  try {
    let _bfuid = getCookie("_bfuid")

    if (_bfuid) {
      // 默认过期与matomo过期时间一致
      setCookie("_bfuid", _bfuid, { expires: new Date(matomoExpiresTime) });
      sendMatomoId(_bfuid)
    } else {
      _bfuid = generateMatomoVisitorId()
      // 如果没生成visitorId
      if (!_bfuid) {
        _bfuid = easyUUID()
      }
      setCookie("_bfuid", _bfuid, { expires: new Date(matomoExpiresTime) });
      sendMatomoId(_bfuid)
      matomoSetCustomDimension(13, _bfuid)
      // 第一次直接return
      return { _bfuid, isFirst: true }
    }

    return { _bfuid, isFirst: false }
  } catch (error: any) {
    const _bfuid = easyUUID()
    setCookie("_bfuid", _bfuid, { expires: new Date(matomoExpiresTime) });
    sendMatomoId(_bfuid)
    matomoSetCustomDimension(13, _bfuid)
  }
}

function settingCookie(expiresTimeNum: number, experimentName: string, bucket: string) {
  // 设置ABtest实验名称，过期时间通过接口返回
  setCookie("X-AB-Experiment-Name", experimentName, { expires: new Date(expiresTimeNum) });

  // abtest奇偶对调
  let paritySwapGroup = bucket
  const startDate: any = new Date('2024-07-22');
  const endDate: any = new Date();

  // 计算时间差（毫秒）
  const timeDifference: any = endDate - startDate;

  // 将时间差转换为天数
  const daysDifference = parseInt(`${timeDifference / (1000 * 60 * 60 * 24)}`);

  if (daysDifference % 2 === 0) {
    paritySwapGroup = bucket === "A" ? "B" : bucket === "B" ? "A" : bucket;
  }
  setCookie("X-Service-Group-AB", paritySwapGroup, { expires: new Date(expiresTimeNum) });
}

function easyUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function errorFunction(resolve: any, response: any) {
  // // console.log("请求AB、指纹ID不正常，使用unique_id");
  // var unique_id = getCookie("unique_id") || ""
  // 使用简单的easyuuid
  const serviceGroup = calculate(easyUUID(), response, true)
  settingCookie(matomoExpiresTime, response.experimentName, "A")
  // console.log(serviceGroup);
  resolve(serviceGroup)
}


const getGroup = async (name: string, _bfuid: string, isFirst: boolean, resolve: any) => {
  if (!name) {
    resolve("A")
    return
  }
  let defaultGroup = "A"
  try {
    const data = await fetch(`/others/getABTestConfig.php?name=${name}`, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': '*/*'
      },
      mode: 'cors'
    })
    if (!data.ok) {
      throw new Error('请求出错：' + data.statusText);
    }

    const response: any = await data.json()

    if (response.default) {
      defaultGroup = response.default
    }

    if (typeof window !== 'undefined') {
      if (_bfuid) {
        const serviceGroup = calculate(_bfuid, response, isFirst)
        if (serviceGroup) {
          // console.log("请求AB、指纹ID正常");
          // console.log(serviceGroup);
          resolve(serviceGroup)
        } else {
          // console.log(`请求AB、指纹ID计算有误，使用默认兜底${defaultGroup}`);
          resolve(defaultGroup)
        }
      } else {
        errorFunction(resolve, response)
      }

    } else {
      // console.log(`不在windows环境，使用默认兜底${defaultGroup}`);
      settingCookie(matomoExpiresTime, name, defaultGroup)
      // 日志上传
      const params = {
        conf: JSON.stringify(response) || null,
        visitorId: "window-error",
        experimentName: name
      }
      uploadLog(params)
      resolve(defaultGroup)
    }

  } catch (error: any) {
    // console.log(`接口挂壁、兜底去${defaultGroup}`);
    settingCookie(matomoExpiresTime, name, defaultGroup)
    // 日志上传
    const params = {
      conf: error.message || null,
      bucketId: "getABTestConfig-error",
      experimentName: name
    }
    uploadLog(params)
    resolve(defaultGroup)
  }
}